const trinityProgressOption = ({kid_name, ordering, stage_progress_percent = 0, current_trinity_stage, trinity_opt_out}) => {

  if (!kid_name || !current_trinity_stage || trinity_opt_out) return null;

  let progressText;
  let progress;

  if (stage_progress_percent <= 33) {
    progressText = 'trinity_progress_low';
    progress = 'low';
  }

  if (stage_progress_percent > 33 && stage_progress_percent < 65) {
    progressText = 'trinity_progress_medium';
    progress = 'medium';
  }

  if (stage_progress_percent >= 65) {
    progressText = 'trinity_progress_high';
    progress = 'high';
  }

  const translateGrade = (stage) => {
    if (stage.toLowerCase().includes('pre-initial')) {
      return {
        current: 'Pre-Initial',
        next: 'Initial'
      }
    }
    if (stage.toLowerCase().includes('initial')) {
      return {
        current: 'Initial',
        next: 'Grade 1'
      }
    }
   if (stage.toLowerCase().includes('grade 1')) {
    return {
      current: 'Grade 1',
      next: 'Grade 2'
    }
    }
    return {
      current: 'Grade 2',
      next: null
    }
  }


  const trinityProgressData = {
    "order": ordering.trinity_progress,
    "name": 'trinity_progress',
    "tracking": progressText,
    "colorOption": 4,
    "dataPoints": {
      kid_name,
      progress,
      current_trinity_stage: translateGrade(current_trinity_stage).current,
      next_trinity_stage: translateGrade(current_trinity_stage).next
    }
  };
  return trinityProgressData;
}

export default trinityProgressOption;
